import { fontSize as fs } from './vars';

export const fontFamily = {
  sans: ['Outfit Variable', 'sans-serif'],
  editor: ['Noto Sans Variable', 'sans-serif'],
};

export const fontSize = {
  xs: fs(12, 16),
  sm: fs(14, 20),
  md: fs(16, 24),
  'label-xs': fs(12, 14),
  'label-sm': fs(14, 16),
  'label-md': fs(16, 18),
  'tpi-score': fs(36, 36),
  'tpi-perc': fs(10, 10),
  'editor-sm': fs(14, 20),
  title: fs(20, 28),
  // deprecated
  xxs: fs(10, 10),
  xl: fs(36, 36),
  lmd: fs(16, 18),
  lxs: fs(12, 14),
  lsm: fs(14, 16),
};

export const fontWeight = {
  normal: '400',
  regular: '500',
  medium: '500',
  semibold: '600',
  bold: '700',
};
